import { Fragment } from 'react';
import heroBg from '@/assets/home/bg.png';
import value1Video from '@/assets/home/value-1.mp4';
import value2Video from '@/assets/home/value-2.mp4';
import value3Video from '@/assets/home/value-3.mp4';
import highlight1 from '@/assets/home/highlight-1.png';
import highlight2 from '@/assets/home/highlight-2.png';
import highlight3 from '@/assets/home/highlight-3.png';
import highlight4 from '@/assets/home/highlight-4.png';
import tech1 from '@/assets/home/tech-1.png';
import tech2 from '@/assets/home/tech-2.png';
import tech3 from '@/assets/home/tech-3.png';
import tech4 from '@/assets/home/tech-4.png';
import productMatrix1 from '@/assets/home/product-matrix-1.png';
import productMatrix2 from '@/assets/home/product-matrix-2.png';
import productMatrix3 from '@/assets/home/product-matrix-3.png';
import productMatrix4 from '@/assets/home/product-matrix-4.png';
import productMatrix5 from '@/assets/home/product-matrix-5.png';
import case1 from '@/assets/home/case-1.png';
import case2 from '@/assets/home/case-2.png';
import honor1 from '@/assets/home/honor-1.png';
import honor2 from '@/assets/home/honor-2.png';
import honor3 from '@/assets/home/honor-3.png';
import honor4 from '@/assets/home/honor-4.png';
import honor5 from '@/assets/home/honor-5.png';
import honor8 from '@/assets/home/honor-8.png';
// import honor7 from '@/assets/home/honor-7.png';

import imgPic1 from '@/assets/home/screen-news/pic-1.png';
import imgPic2 from '@/assets/home/screen-news/pic-2.png';
import imgPic3 from '@/assets/home/screen-news/pic-3.png';
import imgPic4 from '@/assets/home/screen-news/pic-4.png';
import imgPic5 from '@/assets/home/screen-news/pic-5.png';
import imgPic6 from '@/assets/home/screen-news/pic-6.png';
import imgPic7 from '@/assets/home/screen-news/pic-7.png';
import imgPic8 from '@/assets/home/screen-news/pic-8.png';
import imgPic9 from '@/assets/home/screen-news/pic-9.png';
import imgPic10 from '@/assets/home/screen-news/pic-10.png';
import imgPic11 from '@/assets/home/screen-news/pic-11.png';
import imgPic12 from '@/assets/home/screen-news/pic-12.png';
import imgPic13 from '@/assets/home/screen-news/pic-13.png';
import imgPic14 from '@/assets/home/screen-news/pic-14.png';
import imgPic15 from '@/assets/home/screen-news/pic-15.png';
import imgPic16 from '@/assets/home/screen-news/pic-16.png';
import imgPic17 from '@/assets/home/screen-news/pic-17.png';
import imgPic18 from '@/assets/home/screen-news/pic-18.png';
import imgPic19 from '@/assets/home/screen-news/pic-19.png';
import imgPic20 from '@/assets/home/screen-news/pic-20.png';
import imgPic21 from '@/assets/home/screen-news/pic-21.png';
import imgPic22 from '@/assets/home/screen-news/pic-22.png';
import imgIcon1 from '@/assets/home/screen-news/icon-1.png';
import imgIcon2 from '@/assets/home/screen-news/icon-2.png';
import imgIcon3 from '@/assets/home/screen-news/icon-3.png';
import imgIcon4 from '@/assets/home/screen-news/icon-4.png';
import imgIcon5 from '@/assets/home/screen-news/icon-5.png';
import imgIcon6 from '@/assets/home/screen-news/icon-6.png';
import imgIcon8 from '@/assets/home/screen-news/icon-8.png';
import imgIcon9 from '@/assets/home/screen-news/icon-9.png';
import imgIcon10 from '@/assets/home/screen-news/icon-10.png';
import imgIcon13 from '@/assets/home/screen-news/icon-13.png';
import imgIcon14 from '@/assets/home/screen-news/icon-14.png';
import imgIcon16 from '@/assets/home/screen-news/icon-16.png';
import imgIcon18 from '@/assets/home/screen-news/icon-18.png';
import imgIcon22 from '@/assets/home/screen-news/icon-22.png';

export const HERO = {
  kicker: 'AI学就爱学',
  title: '你的专属AI学习智能体',
  image: heroBg,
};

export const VALUE = {
  title: 'AI学习智能体，三重核心价值',
  subTitle: '为用户打造专业、个性且贯穿终身的高价值学习体验',
  cards: [
    {
      title: '真人级交互',
      description: '集成毫秒响应、情感理解，实现多模态融合的类人交互体验。',
      video: value1Video,
    },
    {
      title: '大师级方法',
      description: '沉淀顶尖教育专家方法论，确保专业深度与权威性。',
      video: value2Video,
    },
    {
      title: '专属级陪伴',
      description: '通过持续互动的长短期记忆与适配，实现终身成长的个性化陪伴。',
      video: value3Video,
    },
  ],
};

export const HIGHLIGHT = {
  title: '爱学AI，四大产品特点',
  subTitle: '爱学AI以专注、包容、专属、科学为基石，让学习更高效、更温暖、更智慧',
  cards: [
    {
      title: '更专注',
      lead: '3分钟一次开口，学习专注不走神。',
      detail: '坚信短时高频互动是学习效果的核心保障。',
      image: highlight1,
    },
    {
      title: '更包容',
      lead: '问题答错无压力，AI学伴更耐心。',
      detail: '创造零压力试错环境，保护学习自信心。',
      image: highlight2,
    },
    {
      title: '更专属',
      lead: '学习内容个性化，AI学伴时时在。',
      detail: '拒绝标准化灌输，尊重每个学习者的独特性。',
      image: highlight3,
    },
    {
      title: '更科学',
      lead: 'AI学伴方法好，真人辅助效果好。',
      detail: '融合AI算法与真人教育智慧，实现教学最优解。',
      image: highlight4,
    },
  ],
};

export const TECH = {
  title: '核心技术中枢，进化新引擎',
  subTitle: '爱学致力于利用AI技术，为用户提供专业、个性化、高质量的学习产品',
  rows: [
    {
      title: '爱学大模型\n国内领先的音视频实时\n对话式 AI 学习大模型',
      body: (
        <>
          <p>
            在头部的国产大语言模型基础上基于大量数据进行后训练以及强化学习，训练出具备完全实时对话能力的独家学习大模型。
          </p>
          <p>
            基于上述“实时对话式AI学习大模型”，已实现“实时个性化”全链路AI学习产品，是行业里首个且唯一一个能够支持万人以上一起学习、实时反馈的AI产品。
          </p>
        </>
      ),
      image: tech1,
      imageAlt: '爱学 AI 大模型',
    },
    {
      title: '爱学数字人\n多场景沉浸交互专家',
      body: (
        <>
          <p>
            我们专注于AI数字人技术的创新，现已构建覆盖秒级数字人、3D高斯数字人与大模型数字人的全场景技术体系，打造出真人级、可扩展、可商用的数字人系统，在学习互动、内容创作、虚拟交互等场景成功落地。
          </p>
          <p>数字人具备多模态感知能力：融合表情、情绪、姿态识别，实现情感化智能响应。</p>
        </>
      ),
      image: tech2,
      imageAlt: '爱学数字人',
      reverse: true,
    },
    {
      title: '爱学智能语音\n打造极致的拟真互动沟通',
      body: '多模态语音理解大模型：识别准确率超过 95%。\n拟人化多情感 TTS：根据学习表现，切换鼓励或指导语气。\n纯净沟通体验：声纹过滤杂音，精准判断回答。\n跨语言理解：中文 / 英文 / 方言混合识别。',
      image: tech3,
      imageAlt: '智能语音交互',
      // tags: ['超拟真', '强理解', '零障碍'],
    },
    {
      title: '爱学 AI 工程系统\n极致工程性能与全双工互动',
      body: '高并发：行业首个且唯一支持数万人并发的实时音视频互动。\n低延迟：AI 回复响应延时为 1‑1.6 秒，达到真人交互的水平。\n低成本：每位学习者每小时上课的成本为第三方的十分之一以内。\n全双工：支持学习者随时打断，实现全程双向互动。',
      image: tech4,
      imageAlt: 'AI 工程系统',
      // tags: ['高并发', '低延迟', '高性价比'],
      reverse: true,
      bodyOutset: true,
    },
  ],
};

export const PRODUCT = {
  title: '产品矩阵，业务新布局',
  subTitle: '爱学以多智能体协同的产品矩阵，全面覆盖学习、教学与讲题，构建AI赋能学习的新生态',
  items: [
    {
      title: '爱学AI学习智能体',
      description: '终身学习的个性化成长陪伴。',
      image: productMatrix1,
      link: '/aixue-ai',
    },
    {
      title: '爱学AI低龄段产品',
      description: '思维、人文、双语全面覆盖。',
      image: productMatrix2,
      link: '/aixue-phonics',
    },
    {
      title: '爱学拍讲智能体',
      description: '即拍即讲，分步引导，个性适配。',
      image: productMatrix3,
      link: '/aixue-explain',
    },
    {
      title: '爱学智引平台',
      description: '专属分身，分钟生成，专注创新。',
      image: productMatrix4,
      link: '/aixue-guide',
    },
    // {
    //   title: '虾宝',
    //   description: 'AI Native通识教育，从认知到创作的进阶。',
    //   image: productMatrix5,
    //   link: '/aixue-xiabao',
    // },
  ],
};

export const CASE = {
  title: '公益进校服务，AI新生态',
  subTitle: '爱学以AI技术推动普惠教育，让优质学习资源走进校园，构建教育公益新生态',
  cards: [
    {
      title: '爱学助力海淀区人北实验学校AI语文实验课',
      description:
        '2025年12月7日，爱学携手海淀区人北实验学校落地了“AI语文实验课”，数字人“苏轼”身着宋代文士服饰现身课堂与师生互动。通过实时互动、交流对话，这一跨越千年的数字邂逅，让前沿大模型技术成为连接经典与现代的桥梁，也展现出了“AI+教育”的无限可能，是一次人工智能深度融入教学场景、开启智慧教育的创新实践。',
      image: case1,
    },
    {
      title: '爱学自然拼读走进中关村第二小学万泉河分校',
      description:
        '2025年12月，爱学走进中关村第二小学万泉河分校，旗下产品爱学AI英语成为该校课后服务产品。',
      image: case2,
    },
  ],
};

const multiTitle = (lines: string[]) => {
  const filtered = lines.filter((line) => line.length > 0);
  return (
    <>
      {filtered.map((line, i) => (
        <Fragment key={i}>
          {i > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </>
  );
};

export const NEWS = {
  title: '权威媒体背书，品牌新标杆',
  subTitle: '爱学以卓越的技术实力与成果，获得权威媒体高度认可',
  cards: [
    {
      title: multiTitle(['央视新闻：', '智汇上海共赴AI新未来']),
      summary:
        '央视新媒体直播聚焦教育领域，探访与爱为舞在WAIC的“AI学习实验室”，第一视角呈现当人工智能走进课堂，会给老师的课堂、学生的学习带来怎样的改变。',
      cover: imgPic1,
      mediaLogo: imgIcon1,
      href: 'https://m-live.cctvnews.cctv.com/live/landscape.html?liveRoomNumber=4573929783670833452&toc_style_id=feeds_only_back&track_id=8F10475C-E3FD-4CD9-9204-187A6611F332_806240493006&share_to=wechat',
    },
    {
      title: multiTitle(['爱学：央视新闻WAIC2026专题报道', '与爱为舞代表AI科技企业接受采访']),
      summary:
        '报道聚焦人工智能技术在民生领域的最新落地成果，与爱为舞作为AI原生企业代表，依托大数据技术，将抽象的学习数据转化为具象可感知、沉浸式可体验、强交互的实景化学习场景。',
      cover: imgPic2,
      mediaLogo: imgIcon2,
      href: 'https://channels.weixin.qq.com/finder-preview/pages/sph?id=ASXGGwCOIt',
    },
    {
      title: multiTitle(['新华网客户端：', '与爱为舞亮相2026世界人工智能大会']),
      summary:
        '7月17日，2026世界人工智能大会（WAIC 2026）在上海举办。作为AI原生科技企业代表，与爱为舞首次亮相WAIC，在世博展览馆H2-E505展位打造“爱学AI学习实验室”，通过四大可感知...',
      cover: imgPic3,
      mediaLogo: imgIcon3,
      href: 'https://app.xinhuanet.com/news/article.html?articleId=2026071884f4ff3dd4f345c08e55f49bf0102ab1&timestamp=76595',
    },
    {
      title: multiTitle(['2026WAIC观察：AI应用进入「可体验时代」，AI原生公司与爱为舞给出样本']),
      summary:
        '在今天的 WAIC 现场，首次参展的 AI 原生企业与爱为舞，直接把一座开放式「AI 学习实验室」搬进了世博展览馆。没有大屏循环播片，也不是观众站一圈看完就走。你是真的能坐下来，亲手一试：学习这件事，确实换了个打开方式...',
      cover: imgPic4,
      mediaLogo: imgIcon4,
      href: 'https://mp.weixin.qq.com/s/U9CbR5dS_peZ-SzToK7G6A',
    },
    {
      title: multiTitle(['人民日报：', '数字人技术亮相《2025开学第一课》']),
      summary:
        '9月1日，在《2025开学第一课》的舞台上，一个跨越时空的敬礼，震撼了全国观众——左权将军以数字人形象“复活”，目光坚毅，身姿挺拔……',
      cover: imgPic5,
      mediaLogo: imgIcon5,
      href: 'https://www.peopleapp.com/column/30050149452-500007066548',
    },
    {
      title: multiTitle([
        '新华网：与爱为舞亮相腾讯云AI产业应用大会，深耕教育大模型，打造下一代学习Agent',
      ]),
      summary:
        '作为腾讯云深度合作伙伴，与爱为舞联合创始人、技术负责人王琳受邀登台，带来《从模型能力到智能闭环：爱学大模型及学习Agent的探索与实践》主题演讲，分享与爱为舞打造教育垂类大模型、爱学AI学习智能体的技术路径与落地成果。',
      cover: imgPic6,
      mediaLogo: imgIcon6,
      href: 'https://www.news.cn/tech/20260609/3ee497077591461e9616f38f4e819f9d/c.html',
    },
    {
      title: multiTitle(['爱学：与爱为舞核心AI技术精彩亮相海淀-新加坡教育圆桌会议']),
      summary:
        '2026年5月13日，“AI赋能 创新共生：北京海淀-新加坡教育高质量发展与全球合作”圆桌会议隆重举办……',
      cover: imgPic7,
      mediaLogo: imgIcon2,
      href: 'https://mp.weixin.qq.com/s/EvUhv8zHTlWq0IaKkI-SbQ',
    },
    {
      title: multiTitle(['芥末堆：百万学员之后，爱学AI学习智能体完成低龄段全场景覆盖']),
      summary:
        '近日，爱学AI学习智能体推出针对低龄段的系统性产品布局，围绕孩子最关键的三种核心素养——思维能力、语言能力与人文素养，分别推出爱学AI思维、爱学AI双语、爱学AI人文素养三大解决方案……',
      cover: imgPic8,
      mediaLogo: imgIcon8,
      href: 'https://mp.weixin.qq.com/s/BX4cxGAqwZep6-V1jqItlg',
    },
    {
      title: multiTitle(['国家发展改革委培训中心（宣传中心）赴北京与爱为舞科技有限公司调研']),
      summary:
        '为深入贯彻落实全国两会关于“打造智能经济新形态”，深化拓展“人工智能＋”的重要部署，按照国家发展改革委培训中心（宣传中心）“春耕行动”主题调研计划安排……',
      cover: imgPic9,
      mediaLogo: imgIcon9,
      href: 'https://mp.weixin.qq.com/s/PVHqo3GFsRArq5tdDww2-g',
    },
    {
      title: multiTitle(['新华社：行业首个AI“一对一”落地一年，与爱为舞收获百万级学员体验']),
      summary:
        '近日，AI原生应用企业与爱为舞对外发布首个AI“一对一”导师落地近一年“成绩单”。数据显示，真人级AI导师教出的首批AI学习“原住民”规模已达百万级……',
      cover: imgPic10,
      mediaLogo: imgIcon10,
      href: 'https://h.xinhuaxmt.com/vh512/share/12899821',
    },
    {
      title: multiTitle(['新华网：与爱为舞张怀亭：生成式AI破题“规模化因材施教”']),
      summary:
        '新华网海南博鳌12月5日电（王岩）12月4日，以“AI赋能·智领新质”为主题的2025数智科技创新发展大会在海南博鳌召开……',
      cover: imgPic11,
      mediaLogo: imgIcon6,
      href: 'https://www.news.cn/enterprise/20251223/b9bde90fc1d443c1aa1066683a621c49/c.html',
    },
    {
      title: multiTitle(['爱学：海淀区领导调研北京与爱为舞科技有限公司']),
      summary:
        '12月23日，区委书记张革到北京与爱为舞科技有限公司开展调研，了解企业在海淀成长感受及发展诉求，倾听对优化营商环境相关建议，进一步坚定企业扎根海淀发展信心……',
      cover: imgPic12,
      mediaLogo: imgIcon2,
      href: 'https://mp.weixin.qq.com/s/mvWcTNp6ME5jn0lIbk8qLQ',
    },
    {
      title: multiTitle(['36氪：', '第一批AI原生应用企业，交卷']),
      summary:
        '当大多数企业还在摸索如何“用AI”，这个时代最激进的一批探路者，已经在回答一个终极问题：当一家公司“生而AI”，底层架构和运行逻辑完全建立在AI之上，会发生什么……',
      cover: imgPic13,
      mediaLogo: imgIcon13,
      href: 'https://mp.weixin.qq.com/s/1N6QC-5dVHdC50LpaOer3w?scene=1&click_id=29',
    },
    {
      title: multiTitle(['三联生活周刊：AI时代的第一批原住民: 10后正在怎样长大？']),
      summary:
        '加州硅谷，从未写过一行代码的8岁男孩，仅凭AI助手，用两小时开发出一款新游戏；北京，三年级男孩在AI辅助下完成了一本小说，登上热搜……',
      cover: imgPic14,
      mediaLogo: imgIcon14,
      href: 'https://mp.weixin.qq.com/s/-H3ZJmJJnQyqPaLz-vjPbA',
    },
    {
      title: multiTitle(['机器之心：上线不到一年，收徒百万', '首个真人级AI导师技术底牌首次曝光']),
      summary:
        '第一次见到「爱学」前，王佳佳（化名）害怕和老师互动。这个来自安徽阜阳的初三女生，性格内向，在课堂上几乎从不举手……',
      cover: imgPic15,
      mediaLogo: imgIcon4,
      href: 'https://mp.weixin.qq.com/s/eNVVbsrzHfgscRRhq57yPQ',
    },
    {
      title: multiTitle(['量子位：千人千面的真人级AI名师', '劈开教育「不可能三角」']),
      summary:
        '这位AI导师，出自一家名为「与爱为舞」的AI原生应用企业。自年初上线以来，已累计为百万级用户提供学习陪伴与一对一讲解服务……',
      cover: imgPic16,
      mediaLogo: imgIcon16,
      href: 'https://mp.weixin.qq.com/s/LtyEyZNsZvur8u-o2MSNpw',
    },
    {
      title: multiTitle(['新华网：人机协同重塑教学生态，从“数字人苏轼”入课看与爱为舞的AI教育实践']),
      summary:
        '近日，在北京市海淀区人北实验学校的一堂AI公开课上，千年文豪苏轼“跨越时空”出现在大屏幕上，与六年级学生共同探讨经典名篇《书戴嵩画牛》……',
      cover: imgPic17,
      mediaLogo: imgIcon6,
      href: 'https://www.xinhuanet.com/tech/20251222/c283fdd371e5420da0603e2d0975ceea/c.html',
    },
    {
      title: multiTitle(['极客公园：AI 应用首次实现万人互动共学 与爱为舞重构 AI 教育范式']),
      summary:
        '当大多数 AI 教育产品还在纠结于「像不像真人」、「超越真人」时，与爱为舞已经实现了 AI 导师的规模化服务……',
      cover: imgPic18,
      mediaLogo: imgIcon18,
      href: 'https://www.geekpark.net/news/356798',
    },
    {
      title: multiTitle(['芥末堆：【GET2025】与爱为舞王琳', '爱与AI帮助每个人成为更好的自己']),
      summary:
        '11月17日至18日，芥末堆在北京举办以“教育有AI，学习无界”为主题的GET2025教育科技大会。与爱为舞联合创始人王琳就《从单向输出，到万人互动—“爱学”的AI落地实践》进行了主题分……',
      cover: imgPic19,
      mediaLogo: imgIcon8,
      href: 'https://mp.weixin.qq.com/s/Yms3UAJkAI9O09Odp1Ml4Q',
    },
    {
      title: multiTitle(['芥末堆：真正的AI导师来了！', '与爱为舞发布首款AI产品']),
      summary:
        '10月24日，与爱为舞正式发布首款AI产品——爱学，定位为一款面向全龄人群的终身教育平台。据介绍，“爱学”旨在打造AI一对一教育新范式，营造一个“人人皆学、处处能学、时时可学”的智能学习生......',
      cover: imgPic20,
      mediaLogo: imgIcon8,
      href: 'https://mp.weixin.qq.com/s/Ob_L1ch92118CyzqAGPf8g',
    },
    {
      title: multiTitle(['新华网：AI数字人技术取得突破性进展 与爱为舞发布实时语音驱动框架']),
      summary:
        '近日，我国人工智能应用企业“与爱为舞”研发团队在数字人技术领域取得重要突破，自主研发实时音视频同步动画生成系统……',
      cover: imgPic21,
      mediaLogo: imgIcon6,
      href: 'https://www.xinhuanet.com/tech/20250917/8a47762c73054c3c80ff9176c8a47bc1/c.html',
    },
    {
      title: multiTitle(['北青网：2025世界人工智能大会|与爱为舞创始人分享AI应用创业的思考与实践']),
      summary:
        '7月28日上午，启明创投主办的“创业投资开启AI技术与应用共振周期”论坛，在WAIC主会场上海世博中心举办。作为特邀嘉宾，与爱为舞创始人兼CEO张怀亭以《关于AI应用创业的思考与实践》为题发表主旨演讲......',
      cover: imgPic22,
      mediaLogo: imgIcon22,
      href: 'https://tech.ynet.com/2025/07/28/3918457t3264.html',
    },
  ],
};

export const HONOR = {
  title: '权威认证加冕，品质新桂冠',
  subTitle: '爱学凭借权威认证加冕品质桂冠，以卓越标准引领AI教育高质量发展',
  cards: [
    {
      id: 'ai-plus',
      title: (
        <>
          “人工智能+”
          <br />
          创新应用实践案例
        </>
      ),
      issuer: '新华网联合工业与信息化部软件与集成电路促进中心',
      badge: honor1,
      badgeAlt: '“人工智能+”创新应用实践案例',
    },
    {
      id: 'unicorn-2026',
      title: (
        <>
          2026
          <br />
          年度中国独角兽企业
        </>
      ),
      issuer: '中关村独角兽企业发展联盟',
      badge: honor2,
      badgeAlt: '2026年度中国独角兽企业',
    },
    {
      id: 'high-tech-2025',
      title: (
        <>
          2025
          <br />
          高新技术企业证书
        </>
      ),
      issuer: '北京市科学技术委员会&北京市财政局&国家税务总局北京市税务局',
      badge: honor3,
      badgeAlt: '2025高新技术企业证书',
    },
    {
      id: 'innovative-enterprise',
      title: (
        <>
          北京市
          <br />
          “创新型”中小企业
        </>
      ),
      issuer: '北京市经济和信息化局',
      badge: honor8,
      badgeAlt: '北京市“创新型”中小企业',
    },
    {
      id: 'sme-specialized',
      title: (
        <>
          北京市
          <br />
          “专精特新”中小企业
        </>
      ),
      issuer: '北京市经济和信息化局',
      badge: honor4,
      badgeAlt: '北京市“专精特新”中小企业',
    },
    {
      id: 'ai-pioneer',
      title: (
        <>
          教育
          <br />
          AI先锋企业奖
        </>
      ),
      issuer: '2025GET教育科技大会',
      badge: honor5,
      badgeAlt: '2025GET教育科技大会-教育AI先锋企业奖',
    },
    // {
    //   id: 'innovation-award',
    //   title: (
    //     <>
    //       2025人工智能
    //       <br />
    //       创新创业大赛三等奖
    //     </>
    //   ),
    //   issuer: '上地UPSIDE',
    //   badge: honor6,
    //   badgeAlt: '2025人工智能创新创业大赛三等奖',
    // },
    // {
    //   id: 'craftsman-2026',
    //   title: (
    //     <>
    //       2026
    //       <br />
    //       匠心领学官
    //     </>
    //   ),
    //   issuer: '2026巨量引擎教育FUTURE知识生态大会',
    //   badge: honor7,
    //   badgeAlt: '2026巨量引擎教育FUTURE知识生态大会-2026匠心领学官',
    // },
  ],
};
